import { supabaseAdmin } from '../config/supabase';

/**
 * Zapisuje wpis do dziennika zdarzeń (admin_audit_log).
 * @param {Object} params
 * @param {string} params.section – zakładka (np. "Aktualności", "Wydarzenia")
 * @param {string} params.action – typ operacji: "create" | "update" | "delete" | "publish" | "status_change" | "login" | inny
 * @param {string} [params.entityType] – typ encji (news, event, report, user, contact, ...)
 * @param {string} [params.entityId] – id encji
 * @param {string} [params.entityLabel] – czytelna etykieta (np. tytuł aktualności)
 * @param {string} [params.details] – opis co zostało zmienione
 * @param {Object} [params.extra] – dodatkowe dane (np. { oldStatus, newStatus })
 * @param {Object} user – { id, name, email } z AuthContext
 */
export async function logAction(
  { section, action, entityType, entityId, entityLabel, details, extra },
  user
) {
  try {
    const { error } = await supabaseAdmin.from('admin_audit_log').insert({
      user_id: user?.id ?? null,
      user_name: user?.name ?? null,
      user_email: user?.email ?? null,
      section: section || 'Panel',
      action: action || 'unknown',
      entity_type: entityType ?? null,
      entity_id: entityId != null ? String(entityId) : null,
      entity_label: entityLabel ?? null,
      details: details ?? null,
      extra: extra ?? null,
    });
    if (error) console.error('auditLog: insert error', error);
  } catch (e) {
    console.error('auditLog: exception', e);
  }
}

/** Eksportowana nazwa zakładki – spójna z menu */
export const SECTIONS = {
  NEWS: 'Aktualności',
  EVENTS: 'Wydarzenia',
  REPORTS: 'Zgłoszenia',
  ATTRACTIONS: 'Atrakcje',
  WASTE_SCHEDULE: 'Harmonogram',
  SEGREGACJA: 'Segregacja',
  CONTACT: 'Kontakt',
  APP_SETTINGS: 'Wygląd',
  PUSH_NOTIFICATIONS: 'Powiadomienia',
  TABS: 'Zarządzanie zakładkami',
  USERS: 'Użytkownicy',
  STATUS_REQUESTS: 'Prośby o zmianę statusu',
  PLACES: 'Mapa - Miejsca',
  CATEGORIES: 'Mapa - Kategorie',
  DASHBOARD: 'Dashboard',
  LOGIN: 'Logowanie',
};

export const ACTIONS = {
  CREATE: 'create',
  UPDATE: 'update',
  DELETE: 'delete',
  PUBLISH: 'publish',
  STATUS_CHANGE: 'status_change',
  LOGIN: 'login',
};
